<template>
    <div class="m-portlet m-portlet--head-sm">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">
                        教师请假处理
                    </h3>
                </div>
            </div>
        </div>
        <div class="m-portlet__body">
            <div class="m-widget2">
                <div class="m-widget2__item m-widget2__item--danger">
                    <div class="m-widget2__desc">
															<span class="m-widget2__text">
																Completa Financial Report For Emirates Airlines
															</span><br>
                        <span class="m-widget2__user-name">
																<a  class="m-widget2__link">
																	By Bob
																</a>
															</span>
                    </div>
                    <div class="m-widget2__actions">
                        <div class="m-widget2__actions-nav">

                        </div>
                    </div>
                </div>
                <div class="m-widget2__item m-widget2__item--danger">
                    <div class="m-widget2__desc">
															<span class="m-widget2__text">
																Completa Financial Report For Emirates Airlines
															</span><br>
                        <span class="m-widget2__user-name">
																<a  class="m-widget2__link">
																	By Bob
																</a>
															</span>
                    </div>
                    <div class="m-widget2__actions">
                        <div class="m-widget2__actions-nav">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "TaskTeacherAskForLeaving"
    }
</script>

<style scoped>

</style>
